
/* AutoSEM CRO v4: Exit Intent Overlay */
(function(){
  if(sessionStorage.getItem('autosem_exit_shown'))return;
  var triggered=false;

  function showOverlay(){
    if(triggered)return;
    triggered=true;
    sessionStorage.setItem('autosem_exit_shown','1');

    var overlay=document.createElement('div');
    overlay.id='autosem-exit-overlay';
    overlay.innerHTML='<div style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.6);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;box-sizing:border-box;">'
      +'<div style="background:#fff;border-radius:12px;padding:32px;max-width:420px;width:100%;text-align:center;position:relative;box-shadow:0 20px 60px rgba(0,0,0,0.3);">'
      +'<button onclick="this.closest(\'#autosem-exit-overlay\').remove()" style="position:absolute;top:12px;right:16px;background:none;border:none;font-size:24px;cursor:pointer;color:#999;">&times;</button>'
      +'<div style="font-size:40px;margin-bottom:12px;">&#127934;</div>'
      +'<h2 style="margin:0 0 8px;font-size:22px;color:#1a1a1a;">Wait — 15% Off Your First Order</h2>'
      +'<p style="margin:0 0 20px;font-size:15px;color:#666;">Use code <strong style="color:#2d5a27;font-size:17px;">COURT15</strong> at checkout for 15% off. Free shipping on every order.</p>'
      +'<a href="/collections/all" style="display:inline-block;padding:14px 32px;background:#2d5a27;color:#fff;text-decoration:none;border-radius:6px;font-size:15px;font-weight:600;">Shop the Collection</a>'
      +'<p style="margin:16px 0 0;font-size:12px;color:#999;">Premium tennis & pickleball apparel. Made to order.</p>'
      +'</div></div>';
    document.body.appendChild(overlay);

    overlay.querySelector('div > div').addEventListener('click',function(e){
      if(e.target===overlay.firstChild)overlay.remove();
    });
    overlay.firstChild.addEventListener('click',function(e){
      if(e.target===this)overlay.remove();
    });
  }

  /* Desktop: mouse leaves viewport top */
  document.addEventListener('mouseout',function(e){
    if(e.clientY<5&&!e.relatedTarget)showOverlay();
  });

  /* Mobile: back button intent (history manipulation) */
  if(/Mobi|Android/i.test(navigator.userAgent)){
    setTimeout(function(){
      history.pushState(null,null,location.href);
      window.addEventListener('popstate',function(){
        history.pushState(null,null,location.href);
        showOverlay();
      });
    },10000);
  }
})();
